import { render, staticRenderFns } from "./vender-railbank-edit-form.vue?vue&type=template&id=629cb84e&"
import script from "./vender-railbank-edit-form.vue?vue&type=script&lang=js&"
export * from "./vender-railbank-edit-form.vue?vue&type=script&lang=js&"
import style0 from "./vender-railbank-edit-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports